import React, { Dispatch, SetStateAction } from 'react'

export interface ExceptionState {
  code?: string
  message?: string
  payload?: unknown
}

export type MaybeRequireConfirmation = ExceptionState | null
export type ContextConfirmationType = [
  MaybeRequireConfirmation,
  Dispatch<SetStateAction<MaybeRequireConfirmation>>,
]

export const ConfirmationContext = React.createContext<ContextConfirmationType>([null, () => {}])
